import React, {Component} from 'react';
import Sdk from 'api.digitalpages.module.sdk.api';
import AuthorService from '../../services/AuthorService';
import AOS from 'aos';
import FullCalendar from '@fullcalendar/react';
import ptBrLocale from '@fullcalendar/core/locales/pt-br';
import listPlugin from '@fullcalendar/list';
import AvatarDefault from './default-avatar.png';
import 'aos/dist/aos.css';
import './search-term.css';
import { UsersService } from '../../services/user';
import $ from "jquery";

import {
  HeaderShelf,
  ShelfFeaturedBanner,
  ShelfRecentReadings,
  ShelfYouMightLike,
  SidebarRoundedIcons,
  IaBot,
  IaBotReadingList,
  Categories,
  Card,
  Menu,
  CoinsAndBadges,
  Webview,
  OfflineTooltip,
  OfflineMessageView,
  ArchiveCategories
} from '../../components';
import { Utils } from '../../utils/utils';
export default class ViewSearchTerm extends Component {
  constructor(props) {
    super(props);
    this.calendarRef = React.createRef();
    this.customizedRef = React.createRef();

    this.state = {
      "courses": null,
      "user": null,
      "active_project": null,
      "customization": null,
      "active_tab": null,
      "dates_expanded_list": [Utils.localeDate(new Date())],
      "avatarFile": null,
      "avatarUrl": null,
      "api_context": null,
      "books": null,
      "category": null,
      "current_page": 1,
      "total_pages": 1,
      "loading_books": true,
      "render_search_options": false,
      "render_ai_search": false,
      "search_value": "",
      "authors": []
    }

    this.onUpdateProfile = this.onUpdateProfile.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
  }

  componentWillMount() {
    this.redirectToLogin();
  }

  redirectToLogin() {
    var user = UsersService.getUser();
    if (user === null) {
      window.location = window.location.origin + window.location.pathname + "#/login";
    } else {
      this.continueRequests();
    }
  }

  handleSearchChange(event) {
    this.setState({
      "search_value": event.target.value
    });
  }

  continueRequests() {
    // this.getSearchCategory();
    this.getBooks(this.props.match.params.page || 1);
    this.getApiContext();
    this.redirectToTab();
    this.getUser();
    AOS.init({
      // anchorPlacement: 'top-bottom'
      offset: -50
    });
    this.setState({
      "active_tab": this.getRole().graduacao ? "study" : "courses"
    })
  }

  async getApiContext() {
    const response = await fetch("./api_context.json");
    const config = await response.json();
    this.setState({
      "api_context": config
    })
  }

  async getBooks(page = 1) {
    this.setState({ "loading_books": true });
    
    // Carregar autores e livros em paralelo
    const [authors, books] = await Promise.all([
      AuthorService.loadAuthors(),
      Sdk.Api.dynamic.bridge(`/cms/v1.1/managed/content/available?include_properties=true&include_entities=true&search=${this.props.match.params.term}&page=${page}&page_size=50`)
    ]);

    // fallback caso o livro não retorna com entities vazio
    await Promise.all(
      books.result.map(async (book) => {
        if (!book.entities?.length) {
          const bookData = await Sdk.Api.dynamic.bridge(
            `cms/v1.1/managed/content/group/uid/${book.uid}`,
            null,
            "GET"
          );
          book.entities = bookData.entities;
        }
      })
    );

    // Adicionar autor usando o AuthorService
    const booksWithAuthors = books.result.map(book => ({
      ...book,
      author: this.getBookAuthor(book, authors)
    }));

    this.setState({
      "books": booksWithAuthors,
      "current_page": books.current_page,
      "total_pages": books.total_pages,
      "authors": authors,
      "loading_books": false
    })
  }

  getBookAuthor = (book, authors) => {
    // Primeiro tentar buscar autor nas properties
    let author = book.properties?.find(p => 
      p.name === "Autor" || 
      p.name === "autor" || 
      p.name === "Author" || 
      p.name === "AUTOR"
    )?.value;
    
    // Se não encontrou nas properties, usar a lógica baseada em entities

    if (!author && book.entities && authors.length) {
      author = AuthorService.updateContentAuthor(book, authors);
    }
    
    // Fallbacks adicionais
    if (!author || author === 'Autor não disponível') {
      author = book.author || 
               book.properties?.find(p => p.name.toLowerCase().includes('autor'))?.value ||
               'Autor não informado';
    }
    
    return author;
  }

  async getSearchCategory() {
    var schema = await Utils.bridgeAndStore(`/auth/v1.1/entity/schema/available?type=category`);
    var category = schema.find(cat => cat.name === "Categorias");
    var categories = await Utils.bridgeAndStore(`/auth/v1.1/entity/schema/uid/${category.uid}/items/tree`);

    this.setState({
      "category": categories.find(item => item.uid === this.props.match.params.uid)
    })
  }

  getRole() {
    var roles = Sdk.Api.authorization.user.roles;

    return {
      "graduacao": roles.filter(role => role.type === "Viewer").length > 0,
      "cursos_livres": roles.filter(role => role.type === "LearningViewer").length > 0
    }
  }

  redirectToTab() {
    var tab = Utils.getUrlParam("tab");
    if (tab !== null) {
      this.setState({
        "active_tab": tab
      })
    }
  }

  componentDidMount() {

  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.page !== this.props.match.params.page || 
        prevProps.match.params.term !== this.props.match.params.term) {
      this.getBooks(this.props.match.params.page || 1);
    }
  }

  componentWillUnmount() {

  }


  async signOut() {
    await UsersService.signOut()
    window.location = window.location.origin + window.location.pathname + "#/login";
  }

  async getUser() {
    // var userDetails = await UsersService.getUserDetails();
    var userDetails, avatar;
    
    if (Utils.recoverBridge(`/auth/v1.0/user/me`) !== null) {
      userDetails = Utils.recoverBridge(`/auth/v1.0/user/me`);
      avatar = Sdk.Api.dynamic.bridgeUrl(`/auth/v1.1/user/uid/${(userDetails || {}).uid}/thumb`);

      this.setState({
        "user": {
          ...(userDetails || {}),
          avatar,
        }
      });
    }
    
    userDetails = await Utils.bridgeAndStore(`/auth/v1.0/user/me`, null, 'GET');

    // var userDetails = await Sdk.Api.dynamic.bridge(`/auth/v1.0/user/me`, null, 'GET');
    if (userDetails.detail.name.search("Guest") > -1) {
      this.signOut();
    }
    avatar = Sdk.Api.dynamic.bridgeUrl(`/auth/v1.1/user/uid/${(userDetails || {}).uid}/thumb`);
    // this.setActiveProject(userDetails.projects);

    this.setState({
      "user": {
        ...(userDetails || {}),
        avatar,
      }
    });
  }

  setActiveProject(projects) {
    var activeProjectUid = UsersService.getActiveProjectUid();

    if (activeProjectUid !== null) {
      var activeProject = projects.find(project => project.uid === activeProjectUid);
      Sdk.authorization.setActiveProject(activeProject)
      this.setState({
        "active_project": activeProject
      });

      this.setCustomization(activeProject)
    };
  }

  async setCustomization(activeProject) {
    var customizationConnector = activeProject.connectors.find(connector => connector.type === "Customization_1");
    
    if (window.localStorage.getItem(`connector-${customizationConnector.uid}`)) {
      this.setState({
        "customization": JSON.parse(window.localStorage.getItem(`connector-${customizationConnector.uid}`)).configuration.configs
      });
    };

    if (customizationConnector !== undefined) {
      var connector = await UsersService.getConnector(customizationConnector.uid);
      this.setState({
        "customization": connector.configuration.configs
      });
    }
  }

  onClick(type, uid) {
    window.location = window.location.origin + window.location.pathname + "#/" + type + "/" + uid;
  }

  async onUpdateProfile () {
    const { avatarFile, user } = this.state;
    const formData = new FormData();

    if (!avatarFile || !user) return;

    formData.append('profile', avatarFile);

    await Sdk.Api.dynamic.bridge(`/auth/v1.1/user/me/thumb`, formData, "PUT")
    .then(() => {
      this.setState({ 
        active_tab: 'study',
        user: { 
        ...user, avatar: URL.createObjectURL(avatarFile)
      }});
    })
    .catch(err => {
      console.log(err);
    })
  };

  redirectTo(path) {
    window.location = window.location.origin + window.location.pathname + "#" + path;
  }

  getImageUrl(uid) {
    var url = `${Sdk.Api.domain}/cms/v1.1/managed/content/group/uid/${uid}/default/thumb?image_options=width:200&api_env=${Sdk.Api.enviroment}&project_key=${Sdk.Api.projectKey}&access_token=${Sdk.Api.authorization.credential.accessToken}`;

    return url;
  }

  getCustomOptions() {
    return `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`;
  }

  onPageChange(page) {
    window.location.hash = `#/search/term/${page}/${this.props.match.params.term}`;
  }

  render() {
    var _this = this;
    const {
      user,
      books,
      category,
      current_page,
      total_pages,
      loading_books,
      render_ai_search,
      render_search_options,
      search_value
    } = this.state;
    
    const { name, first_name, last_name } = (user || { detail: {}}).detail;

    return (<div className="rdp-react-template-view-search-term">

      {render_search_options &&
        <div className="rdp-react-template-view-biblioteca-search-options">
          <div className="rdp-react-template-view-biblioteca-search-options-overlay" onClick={() => this.setState({"render_search_options": false})}></div>
          <ul className="rdp-react-template-view-biblioteca-search-options-items">
            <li className="rdp-react-template-view-biblioteca-search-options-item" style={{
              backgroundImage: "none",
              paddingRight: "18px",
              cursor: "default"
            }}>
              <span className="rdp-react-template-view-biblioteca-search-options-item-icon metadata">🔎</span>
              <div className="rdp-react-template-view-biblioteca-search-options-item-data">
                <span className="rdp-react-template-view-biblioteca-search-options-item-title">Busca Estruturada por Metadados</span>
                <p className="rdp-react-template-view-biblioteca-search-options-item-description">
                  Permite localizar livros a partir de informações cadastrais como título, autor, editora, ISBN, ano de publicação, categorias, palavras-chave e outros metadados. Ideal para buscas objetivas e precisas.
                </p>
                <div className="header-shelf-search-container" style={{
                  width: "100%",
                  cursor: "inherit",
                  marginTop: "20px"
                }}>
                  <input 
                    type="text" 
                    placeholder="Encontre aqui o seu livro"
                    className="header-shelf-search-input"
                    onChange={this.handleSearchChange}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter' && search_value.length >= 3) {
                        this.setState({"render_search_options": false});
                        this.redirectTo(`/search/term/1/${search_value}`);
                      }
                    }}
                    style={{
                      pointerEvents: "auto",
                      paddingLeft: "15px"
                    }}
                  />
                  <svg className="header-shelf-search-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                    style={{
                      left: "unset",
                      right: "8px",
                      cursor: "pointer",
                      zIndex: "999",
                      pointerEvents: "auto",
                      opacity: search_value.length >= 3 ? "1" : "0.5"
                    }}
                    onClick={() => {
                      if (search_value.length >= 3) {
                        this.setState({"render_search_options": false});
                        this.redirectTo(`/search/term/1/${search_value}`);
                      }
                    }}
                  >
                    <path d="M21 21L16.514 16.506L21 21ZM19 10.5C19 15.194 15.194 19 10.5 19C5.806 19 2 15.194 2 10.5C2 5.806 5.806 2 10.5 2C15.194 2 19 5.806 19 10.5Z" stroke="#005496" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              </div>
            </li>
            {/* <li className="rdp-react-template-view-biblioteca-search-options-item inactive" onClick={() => {
               this.setState({
                "render_search_options": false,
                "render_ai_search": true
              })
            }}>
              <span className="rdp-react-template-view-biblioteca-search-options-item-icon ai">🤖</span>
              <div className="rdp-react-template-view-biblioteca-search-options-item-data">
                <span className="rdp-react-template-view-biblioteca-search-options-item-title">EM BREVE: Busca Inteligente por Conteúdo (IA)</span>
                <p className="rdp-react-template-view-biblioteca-search-options-item-description">
                  Utiliza Inteligência Artificial para compreender a intenção da busca e analisar o conteúdo completo dos livros, retornando resultados mesmo quando o termo pesquisado não aparece literalmente, mas está relacionado ao tema, contexto ou significado do texto.
                </p>
              </div>
            </li> */}
          </ul>
        </div>
      }

      {render_ai_search &&
        <IaBotReadingList
          booksData={this.state.books}
          textoExtraido={this.state.books}
          apiContext={this.state.api_context}
          accessToken={Sdk.authorization.credential.accessToken}
          aiConnector={Sdk.authorization.activeProject.connectors.find(conn => 
            conn.features && conn.features.find(feat => feat.search("IConnectorGenerativeIA") > -1)
          ) || {
            "features": [
                "IConnectorInstance",
                "IConnectorGenerativeIA",
                "IConnectorContextRequired",
                "IConnectorDetail"
            ],    
            "internal_name": "Google IA",
            "name": "Vertex",
            "scope": "Project",
            "type": "Custom",
            "uid": "9d28a846-e6ca-f011-8197-0022483811fe"
          }}
          onBookSelect={(book) => this.redirectTo(`/book/${book.uid}`)}
          onClose={() => this.setState({"render_ai_search": false})}
          customOptions={this.getCustomOptions()}
        />
      }

      <div
        className="rdp-react-template-view-search-term-header"
        style={{
          position: "fixed",
          top: "0px",
          left: "0px",
          right: "0px",
          width: "100%",
          height: "100px",
          zIndex: 1
        }}
      >
        <HeaderShelf
          onSignOut={() => { this.signOut() }}
          onEditClick={() => {
            window.location.hash = 'perfil';
          }}
          name={user && user.detail && user.detail.name.split(" ")[0]}
          level="Nível 1"
          coins={this.state.coins}
          coinsLabel="BV Coins"
          onCoinsClick={() => this.onCoinsClick()}
          avatar={user && user.avatar ? user.avatar : undefined}
          onSearchClick={() => this.setState({"render_search_options": true})}
        />
      </div>

      <div
        className="rdp-react-template-view-search-term-sidebar"
        style={{
          width: "50px",
          position: "fixed",
          top: "100px",
          bottom: "0px",
          left: "0px"
        }}
      >
        <SidebarRoundedIcons/>
      </div>

      <div
        className="rdp-react-template-view-search-term-main"
        style={{
          position: "fixed",
          top: "100px",
          bottom: "0px",
          left: "50px",
          right: "0px",
          overflowX: "hidden",
          overflowY: "auto"
        }}
      >
        <div className="rdp-react-template-view-search-term-breadcrumb">
          <button className="rdp-react-template-view-search-term-breadcrumb-item" onClick={() => this.redirectTo("/")}>
            <div className="rdp-react-template-view-search-term-breadcrumb-item-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"><path fill="#084c8a" d="M25.16,13.82L15.59,5.51c-.34-.29-.84-.29-1.18,0L4.84,13.83c-.37.32-.41.89-.09,1.26.17.19.41.31.67.31h2.37v8.41c0,.49.4.9.9.9h3.38c.49,0,.9-.4.9-.9,0,0,0,0,0,0v-5.93h3.95v5.93c0,.49.4.9.9.9h3.33c.49,0,.9-.4.9-.9,0,0,0,0,0,0v-8.41h2.53c.49,0,.9-.4.9-.9,0-.26-.11-.51-.31-.68ZM22.01,14.46c-.49,0-.9.4-.9.9v8.41h-3.26v-5.93c0-.5-.4-.9-.9-.9,0,0,0,0,0,0h-4.02c-.49,0-.9.4-.9.9v5.93h-3.3v-8.41c0-.49-.4-.9-.9-.9h-2.31L15,6.23l9.48,8.23h-2.47Z"></path></svg>
            </div>
            <span className="rdp-react-template-view-search-term-breadcrumb-item-label">Biblioteca</span>
          </button>
          <span className="rdp-react-template-view-search-term-breadcrumb-chevron"></span>
          <span className="rdp-react-template-view-search-term-breadcrumb-category">Busca</span>
          <span className="rdp-react-template-view-search-term-breadcrumb-chevron"></span>
          <span className="rdp-react-template-view-search-term-breadcrumb-category">{this.props.match.params.term}</span>
        </div>
        <div className="rdp-react-template-view-search-term-items">
          {loading_books ? (
            Array.from({length: 12}, (_, index) => (
              <div key={index} className="rdp-react-template-view-search-term-item skeleton">
                <div className="rdp-react-template-view-search-term-item-cover skeleton-cover"></div>
                <div className="rdp-react-template-view-search-term-item-title skeleton-title"></div>
                <div className="rdp-react-template-view-search-term-item-edition skeleton-edition"></div>
              </div>
            ))
          ) : (
            books && books.map(function (book, index) {
              return <div
                className={`rdp-react-template-view-search-term-item`}
                key={book.uid}
                onClick={() => _this.redirectTo(`/book/${book.uid}`)}
              >
                <img
                  className="rdp-react-template-view-search-term-item-cover blur"
                  src={_this.getImageUrl(book.uid)}
                  loading="lazy"
                  onLoad={(e) => e.target.classList.add('loaded')}
                />
                <div className="rdp-react-template-view-search-term-item-title">
                  {book.name}
                </div>
                <div className="rdp-react-template-view-search-term-item-title" style={{marginTop: '10px', fontWeight: '1000', fontSize: '10px', height: "28px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}}>
                  {book.author}
                </div>
                <div className="rdp-react-template-view-search-term-item-edition">
                  {book.edition}
                </div>
              </div>
            })
          )}
        </div>
        
        {total_pages > 1 && (
          <div className="rdp-react-template-view-search-term-pagination">
            <button 
              className="rdp-react-template-view-search-term-pagination-btn left"
              disabled={current_page === 1}
              onClick={() => _this.onPageChange(current_page - 1)}
            >
              Anterior
            </button>
            
            <div className="rdp-react-template-view-search-term-pagination-pages">
              {(() => {
                const maxPages = Math.min(5, total_pages);
                let startPage = Math.max(1, current_page - Math.floor(maxPages / 2));
                let endPage = Math.min(total_pages, startPage + maxPages - 1);
                
                if (endPage - startPage + 1 < maxPages) {
                  startPage = Math.max(1, endPage - maxPages + 1);
                }
                
                const pages = [];
                for (let i = startPage; i <= endPage; i++) {
                  pages.push(i);
                }
                
                return pages.map(page => (
                  <button
                    key={page}
                    className={`rdp-react-template-view-search-term-pagination-page ${current_page === page ? 'active' : ''}`}
                    onClick={() => _this.onPageChange(page)}
                  >
                    {page}
                  </button>
                ));
              })()}
            </div>
            
            <button 
              className="rdp-react-template-view-search-term-pagination-btn right"
              disabled={current_page === total_pages}
              onClick={() => _this.onPageChange(current_page + 1)}
            >
              Próxima
            </button>
          </div>
        )}
      </div>

    </div>);
  }
}